
import { WorldCountry } from '../types';

export const slovakiaExpanded: WorldCountry = {
  name: 'Slovakia',
  slug: 'slovakia',
  code: 'SK',
  population: 5458827,
  topCities: [
    { name: 'Bratislava', slug: 'bratislava', population: 432864 },
    { name: 'Košice', slug: 'kosice', population: 238757 },
    { name: 'Prešov', slug: 'presov', population: 91352 },
    { name: 'Žilina', slug: 'zilina', population: 80386 },
    { name: 'Banská Bystrica', slug: 'banska-bystrica', population: 78327 },
    { name: 'Nitra', slug: 'nitra', population: 77302 },
    { name: 'Trnava', slug: 'trnava', population: 65033 },
    { name: 'Martin', slug: 'martin-sk', population: 55316 },
    { name: 'Trenčín', slug: 'trencin', population: 55416 },
    { name: 'Poprad', slug: 'poprad', population: 50998 },
    
    // Expansión: 90 ciudades adicionales
    { name: 'Prievidza', slug: 'prievidza', population: 45989 },
    { name: 'Zvolen', slug: 'zvolen', population: 42092 },
    { name: 'Považská Bystrica', slug: 'povazska-bystrica', population: 40084 },
    { name: 'Michalovce', slug: 'michalovce', population: 39846 },
    { name: 'Spišská Nová Ves', slug: 'spisska-nova-ves', population: 37447 },
    { name: 'Komárno', slug: 'komarno', population: 34446 },
    { name: 'Levice', slug: 'levice', population: 34156 },
    { name: 'Humenné', slug: 'humenne', population: 33794 },
    { name: 'Bardejov', slug: 'bardejov', population: 33056 },
    { name: 'Liptovský Mikuláš', slug: 'liptovsky-mikulas', population: 31688 },
    { name: 'Ružomberok', slug: 'ruzomberok', population: 27352 },
    { name: 'Dolný Kubín', slug: 'dolny-kubin', population: 19261 },
    { name: 'Vranov nad Topľou', slug: 'vranov-nad-toplou', population: 22383 },
    { name: 'Senica', slug: 'senica', population: 20756 },
    { name: 'Dunajská Streda', slug: 'dunajska-streda', population: 22477 },
    { name: 'Čadca', slug: 'cadca', population: 24871 },
    { name: 'Rimavská Sobota', slug: 'rimavska-sobota', population: 24135 },
    { name: 'Topoľčany', slug: 'topolcany', population: 25648 },
    { name: 'Galanta', slug: 'galanta', population: 15181 },
    { name: 'Lučenec', slug: 'lucenec', population: 28356 },
    { name: 'Trebišov', slug: 'trebisov', population: 23131 },
    { name: 'Malacky', slug: 'malacky', population: 17168 },
    { name: 'Rožňava', slug: 'roznava', population: 19182 },
    { name: 'Turčianske Teplice', slug: 'turcianske-teplice', population: 6660 },
    { name: 'Dubnica nad Váhom', slug: 'dubnica-nad-vahom', population: 25210 },
    { name: 'Myjava', slug: 'myjava', population: 12380 },
    { name: 'Hlohovec', slug: 'hlohovec', population: 21508 },
    { name: 'Skalica', slug: 'skalica', population: 15001 },
    { name: 'Šaľa', slug: 'sala', population: 25114 },
    { name: 'Pieštany', slug: 'piestany', population: 28327 },
    { name: 'Pezinok', slug: 'pezinok', population: 23872 },
    { name: 'Modra', slug: 'modra', population: 9153 },
    { name: 'Senec', slug: 'senec', population: 20384 },
    { name: 'Stupava', slug: 'stupava', population: 11975 },
    { name: 'Svätý Jur', slug: 'svaty-jur', population: 5698 },
    { name: 'Bernolákovo', slug: 'bernolakovo', population: 5893 },
    { name: 'Ivanka pri Dunaji', slug: 'ivanka-pri-dunaji', population: 4234 },
    { name: 'Chorvátsky Grob', slug: 'chorvatsky-grob', population: 3567 },
    { name: 'Slovenský Grob', slug: 'slovensky-grob', population: 2987 },
    { name: 'Viničné', slug: 'vinicne', population: 2134 },
    { name: 'Záhorská Bystrica', slug: 'zahorska-bystrica', population: 3456 },
    { name: 'Tomášov', slug: 'tomasov', population: 2987 },
    { name: 'Kostolište', slug: 'kostoliste', population: 1876 },
    { name: 'Gajary', slug: 'gajary', population: 2345 },
    { name: 'Láb', slug: 'lab', population: 1654 },
    { name: 'Plavecký Štvrtok', slug: 'plavecky-stvrtok', population: 2876 },
    { name: 'Vysoká pri Morave', slug: 'vysoka-pri-morave', population: 1987 },
    { name: 'Devínska Nová Ves', slug: 'devinska-nova-ves', population: 15654 },
    { name: 'Vrakuňa', slug: 'vrakuna', population: 23456 },
    { name: 'Podunajské Biskupice', slug: 'podunajske-biskupice', population: 14567 },
    { name: 'Ružinov', slug: 'ruzinov', population: 67890 },
    { name: 'Karlova Ves', slug: 'karlova-ves', population: 34567 },
    { name: 'Dúbravka', slug: 'dubravka', population: 45678 },
    { name: 'Lamač', slug: 'lamac', population: 6789 },
    { name: 'Záhorská Ves', slug: 'zahorska-ves', population: 2345 },
    { name: 'Devín', slug: 'devin', population: 987 },
    { name: 'Čunovo', slug: 'cunovo', population: 2134 },
    { name: 'Jarovce', slug: 'jarovce', population: 3456 },
    { name: 'Rusovce', slug: 'rusovce', population: 1876 },
    { name: 'Petržalka', slug: 'petrzalka', population: 98765 },
    { name: 'Nové Mesto', slug: 'nove-mesto-ba', population: 34567 },
    { name: 'Staré Mesto', slug: 'stare-mesto-ba', population: 45678 },
    { name: 'Vajnory', slug: 'vajnory', population: 4567 },
    { name: 'Krasňany', slug: 'krasnany', population: 3456 },
    { name: 'Rača', slug: 'raca', population: 5678 },
    { name: 'Nivy', slug: 'nivy', population: 12345 },
    { name: 'Bratislava-Staré Mesto', slug: 'bratislava-stare-mesto', population: 23456 },
    { name: 'Bratislava-Podunajské Biskupice', slug: 'bratislava-podunajske-biskupice', population: 14567 },
    { name: 'Bratislava-Ružinov', slug: 'bratislava-ruzinov', population: 67890 },
    { name: 'Bratislava-Vrakuňa', slug: 'bratislava-vrakuna', population: 23456 },
    { name: 'Bratislava-Nové Mesto', slug: 'bratislava-nove-mesto', population: 34567 },
    { name: 'Bratislava-Karlova Ves', slug: 'bratislava-karlova-ves', population: 34567 },
    { name: 'Bratislava-Dúbravka', slug: 'bratislava-dubravka', population: 45678 },
    { name: 'Bratislava-Lamač', slug: 'bratislava-lamac', population: 6789 },
    { name: 'Bratislava-Devín', slug: 'bratislava-devin', population: 987 },
    { name: 'Bratislava-Devínska Nová Ves', slug: 'bratislava-devinska-nova-ves', population: 15654 },
    { name: 'Bratislava-Záhorská Bystrica', slug: 'bratislava-zahorska-bystrica', population: 3456 },
    { name: 'Bratislava-Petržalka', slug: 'bratislava-petrzalka', population: 98765 },
    { name: 'Bratislava-Jarovce', slug: 'bratislava-jarovce', population: 3456 },
    { name: 'Bratislava-Rusovce', slug: 'bratislava-rusovce', population: 1876 },
    { name: 'Bratislava-Čunovo', slug: 'bratislava-cunovo', population: 2134 },
    { name: 'Hurbanovo', slug: 'hurbanovo', population: 7652 },
    { name: 'Šurany', slug: 'surany', population: 11234 },
    { name: 'Kolárovo', slug: 'kolarovo', population: 10234 },
    { name: 'Želiezovce', slug: 'zeliezovce', population: 7345 },
    { name: 'Levice-Tlmače', slug: 'levice-tlmace', population: 4567 },
    { name: 'Zlaté Moravce', slug: 'zlate-moravce', population: 13234 },
    { name: 'Vráble', slug: 'vrabel', population: 8765 },
    { name: 'Nové Zámky', slug: 'nove-zamky', population: 40548 },
    { name: 'Štúrovo', slug: 'sturovo', population: 10592 },
    { name: 'Šahy', slug: 'sahy', population: 7971 },
    { name: 'Ipeľský Sokolec', slug: 'ipelsky-sokolec', population: 1234 },
    { name: 'Hontianske Nemce', slug: 'hontianske-nemce', population: 987 },
    { name: 'Želiezovce', slug: 'zeliezovce-alt', population: 6789 },
    { name: 'Santovka', slug: 'santovka', population: 2345 },
    { name: 'Tekovské Lužany', slug: 'tekovske-luzany', population: 1876 },
    { name: 'Hronský Beňadik', slug: 'hronsky-benadik', population: 1345 },
    { name: 'Žiar nad Hronom', slug: 'ziar-nad-hronom', population: 19150 },
    { name: 'Banská Štiavnica', slug: 'banska-stiavnica', population: 10243 },
    { name: 'Kremnica', slug: 'kremnica', population: 5225 },
    { name: 'Nová Baňa', slug: 'nova-bana', population: 4538 }
  ]
};
